//
//
//
//
//
//
//


import {mapGetters} from 'vuex';

export default {
  props: ["data"],
  block: 'animation',
  computed: {
    ...mapGetters([
      'isMobile',
    ]),
    src() {
      let file = this.data.src;
      if (this.isMobile){
        if (this.data.srcMobile){
          file = this.data.srcMobile;
        }
      }
      return require("@/assets/animations/"+file);
    },
  },
  mounted: function mounted(){
    this.animation = lottie.loadAnimation({
      animationData: this.src,
      container: this.$el,
      renderer: 'svg',
      loop: this.data.loop || false,
      autoplay: this.data.autoplay || false,
      animationSpeed: this.data.animationSpeed || 1,
      // shouldRasterizeWhenIdle: false,
    });

    // Try below to check if page has loaded before calculating offset
    if (document.readyState == "complete") {
      this.offset = this.getOffset();
    }

    // Only animate on scroll if autoplay is false or unset
    if (!this.data.autoplay) {
      this.animation.animationSpeed = this.data.animationSpeed || 1;

      this.animationFrames = this.animation.getDuration(true);
      const elem = document.body; // Scrolling element

      const elemHeight = this.$el.offsetHeight; // Get height of this animation element
      this.stepLength = elemHeight/(this.animationFrames);

      // Get Y position of this animation element

      // TBD need to find a good way to detect when the dom is finished loading
      // So that we can get the offset for the element
      setTimeout(()=>{
        this.offset = this.getOffset();

        if (this.offset < 0) 
          this.offset = 0; // Ensure we never end up with a negative offset

        let lastScrollTop = 0;
        document.body.addEventListener("scroll", () => { 
          const st = window.pageYOffset || elem.scrollTop;
          if (st > lastScrollTop){
          this.scrollDown(lastScrollTop);
          } else {
          this.scrollUp(lastScrollTop);
          }
          lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
        }, false);

      }, 400);

    }
  },
  methods: {
    getOffset() {
      const bodyRect = document.body.getBoundingClientRect();
      const elemRect = this.$el.getBoundingClientRect();

      let preOffset = (this.isMobile) ? 400 : 700;

      // Consider height of device
      const innerHeight = window.innerHeight;
      preOffset = (innerHeight < 1000) ? 400 : 700;

      return (elemRect.top - bodyRect.top - preOffset);
    },
    getBlockModifiers() {
      let bms = this.block;
      if (this.data.blockModifiers) {
        this.data.blockModifiers.forEach( (blockModifier, index) => {
          bms += ' bm-'+blockModifier;
        });
      }

      return bms;
    },
    scrollUp(lastScrollTop){
      if (lastScrollTop > this.offset){
        this.animation.setDirection(-1);
        this.animateWithDistance(lastScrollTop);
      } 
    },
    scrollDown(lastScrollTop){
      if (lastScrollTop > this.offset){
        this.animation.setDirection(1);
        this.animateWithDistance(lastScrollTop);
      } 
    },
    animateWithDistance(lastScrollTop){
      const distance = lastScrollTop - this.offset;
      const frame = Math.round(distance/this.stepLength);

      if (frame > 0 && frame < this.animationFrames){
        this.animation.goToAndStop(frame, true);
      }
    },
  },
}



// WEBPACK FOOTER //
// ./components/blocks/Animation.vue